module.exports = __webpack_public_path__ + "img/product-shot_03.0ff929a3.jpg";